import { useTranslation } from 'react-i18next';
import { TranslationsKeys } from '../../../../../locales/translations';

export function useTexts() {
  const { t } = useTranslation(
    TranslationsKeys.MANAGEMENT_TOOLS_CLASSROOM_CALENDAR,
  );
  return {
    classroomDetailBox: {
      classroomName: t('classroomDetailBox.classroomName'),
      code: t('classroomDetailBox.code'),
      classroomType: t('classroomDetailBox.classroomType'),
      school: t('classroomDetailBox.school'),
    },
    reserveClassroomButton: t('reserveClassroomButton'),
    viewCalendar: t('viewCalendar'),
    teachers: t('teachers'),
    form: {
      cardTitle: t('form.cardTitle'),
      cardSubtitle: t('form.cardSubtitle'),
      startDate: t('form.startDate'),
      endDate: t('form.endDate'),
      dateRangeError: t('form.dateRangeError'),
      startTime: t('form.startTime'),
      endTime: t('form.endTime'),
      title: t('form.title'),
      description: t('form.description'),
      error: t('form.error'),
      conflictError: t('form.conflictError'),
      modulesError: t('form.modulesError'),
      success: t('form.success'),
      submit: t('form.submit'),
      cancel: t('form.cancel'),
    },
    delete: {
      actionLabel: t('delete.actionLabel'),
      title: t('delete.title'),
      subtitle: t('delete.subtitle'),
      // Con placeholder: la interpolación la tiene que hacer i18next. Si se
      // resuelve el texto acá y se reemplaza después, i18next ya borró el
      // `{{days}}` por no recibir la variable y el número desaparece.
      seriesSubtitle: (days: number) => t('delete.seriesSubtitle', { days }),
      successSeries: (deleted: number) =>
        t('delete.successSeries', { deleted }),
      keptPast: t('delete.keptPast'),
      success: t('delete.success'),
      error: t('delete.error'),
      options: {
        onlyThisDay: t('delete.options.onlyThisDay'),
        allDays: (days: number) => t('delete.options.allDays', { days }),
      },
      buttons: {
        cancel: t('delete.buttons.cancel'),
        delete: t('delete.buttons.delete'),
      },
    },
  };
}
